import moment from "moment";

export const getDateAddHourCurrentDate = async (hours: number = 0) => {
    return moment.utc(new Date()).local().add(hours, 'hours').format('YYYY-MM-DD');
}
